import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { ProductTomos } from './components/ProductTomos';
import { Bonuses } from './components/Bonuses';
import { PricingSection } from './components/PricingSection';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-brand-cream font-sans selection:bg-brand-primary selection:text-brand-darker" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <PainPoints data-id="element-3" />
      <ProductTomos data-id="element-4" />
      <Bonuses data-id="element-5" />
      <PricingSection data-id="element-6" />
      <Testimonials data-id="element-7" />
      <Guarantee data-id="element-8" />
      <FAQ data-id="element-9" />
      <CostComparison data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}